import React, { memo } from "react";
import { AnimatePresence } from "framer-motion";
import { MotionDiv, slideInVariants } from "./MediaAssetsLabs.styled";
import Layout from "./layout/Layout";

/**
 * MediaAssetsLab component renders a sliding animation container that includes the Layout component.
 * It only renders when `isVisible` is true, and animates using Framer Motion's AnimatePresence.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.isVisible - Controls the visibility of the component. If true, the component will be rendered and animated in.
 * @param {string} props.campaignId - The ID of the campaign to be passed to the Layout component.
 * @param {boolean} props.isReleased - Determines if the campaign is released. Passed as a prop to the Layout component.
 * @returns {JSX.Element} The MediaAssetsLab component wrapped in a motion div.
 */

const MediaAssetsLab = ({ isVisible, campaignId, isReleased }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <MotionDiv
          key="mediaAssetsLab"
          variants={slideInVariants}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Layout campaignId={campaignId} isReleased={isReleased} />
        </MotionDiv>
      )}
    </AnimatePresence>
  );
};

// Memoize the component separately
const MemoizedMediaAssetsLab = memo(MediaAssetsLab);
export default MemoizedMediaAssetsLab;
